import NoTenant from "./NoTenant";

export default NoTenant;
